/* global process */
import classnames from 'classnames';
import React from 'react';
import uuid from 'uuid';
import styles from './BadgeTooltip.scss';
import Icon from './Icon';
import TranslationContext from './Translations/TranslationContext';
import Popover from './Popover';
import Spinner from './Spinner';
export default class BadgeTooltip extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            popoverOpen: false,
            elId: '',
        };
        this.handleOpenPopover = e => {
            e.preventDefault();
            e.stopPropagation();
            this.setState({ popoverOpen: true });
            const { onOpen } = this.props;
            if (onOpen) {
                onOpen();
            }
        };
        this.handleClosePopover = e => {
            e.preventDefault();
            this.setState({ popoverOpen: false });
            const { onClose } = this.props;
            if (onClose) {
                onClose();
            }
        };
    }
    componentDidMount() {
        if (process.env.BROWSER) {
            const { modelId } = this.props;
            const elId = modelId ? `tooltip-${modelId}` : `tooltip-${uuid.v4()}`;
            /* eslint-disable react/no-did-mount-set-state */
            this.setState({ elId });
        }
    }
    render() {
        const { isLayoutRTL } = this.context || {};
        const { title, position, children, trigger, icon, hasNoLabel, isAuditHistory, isCloseButton, tooltipClassName, tooltipWrapperClassName, iconType, iconClassName, offsetTop, isTransparent, contentWrapperClassName, isDisableClick, } = this.props;
        const { popoverOpen, elId } = this.state;
        if (!elId) {
            return <Spinner />;
        }
        const wrapperProps = trigger === 'hover'
            ? {
                onMouseMove: this.handleOpenPopover,
                onMouseLeave: this.handleClosePopover,
            }
            : {};
        const tooltipProps = trigger === 'hover'
            ? { key: `Hovertooltip_${elId}` }
            : { key: `Clicktooltip_${elId}` };
        return (<div className={classnames(styles.tooltipWrapper, tooltipWrapperClassName)} onClick={isDisableClick ? undefined : this.handleOpenPopover} {...wrapperProps}>
        <span className={classnames('valign-top', styles.label, tooltipClassName, {
            'ml-5': !isTransparent && !isLayoutRTL,
            'mr-5': !isTransparent && isLayoutRTL,
            'label label-success ': !hasNoLabel,
            [styles.labelText]: !icon && !isTransparent,
            [styles.auditHistoryButton]: isAuditHistory,
        })} data-toggle="popover" id={elId} {...tooltipProps}>
          {icon ? (<Icon className={iconClassName} name={icon} type={iconType}/>) : (title)}
        </span>
        <Popover anchorId={elId} contentWrapperClassName={contentWrapperClassName} isCloseButton={isCloseButton} key={`popover_${elId}`} offsetTop={offsetTop} onClose={this.handleClosePopover} position={position} visible={popoverOpen}>
          {children}
        </Popover>
      </div>);
    }
}
BadgeTooltip.defaultProps = {
    position: 'left',
    trigger: 'hover',
    icon: null,
    hasNoLabel: false,
    isAuditHistory: false,
    isDisableClick: false,
    modelId: null,
    title: '',
    isCloseButton: false,
    tooltipClassName: null,
    tooltipWrapperClassName: null,
    iconType: '',
    iconClassName: '',
    offsetTop: 0,
    isTransparent: false,
    onOpen: null,
    onClose: null,
};
BadgeTooltip.contextType = TranslationContext;
